import * as React from 'react';
const SvgFirebase = (props) => (
  <svg viewBox="0 0 52 69" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m0 55.581.43-.583 20.305-37.417.043-.396-8.95-16.33a1.64 1.64 0 0 0-.732-.69c-.313-.149-.666-.199-1.01-.143-.343.057-.66.217-.905.457-.244.24-.405.55-.46.885L0 55.58Z"
      fill="#FFC24A"
    />
    <path
      d="m.253 55.135.324-.615 20.095-37.029-8.927-16.394a1.498 1.498 0 0 0-.68-.659 1.559 1.559 0 0 0-.95-.131 1.532 1.532 0 0 0-.841.448 1.457 1.457 0 0 0-.398.848L.253 55.135Z"
      fill="#FFA712"
    />
    <path
      d="m27.302 29.532 6.664-6.64L27.3 10.543a1.69 1.69 0 0 0-.631-.642 1.755 1.755 0 0 0-1.763 0 1.69 1.69 0 0 0-.632.642l-3.562 6.597v.563l6.59 11.83Z"
      fill="#F4BD62"
    />
    <path
      d="m27.183 29.262 6.48-6.444-6.48-12.002a1.455 1.455 0 0 0-.521-.646 1.526 1.526 0 0 0-1.62-.069c-.248.142-.449.35-.578.6l-3.58 6.712-.106.341 6.405 11.508Z"
      fill="#FFA50E"
    />
    <path
      d="m.005 55.58.195-.192.706-.278 25.976-25.14.33-.87-6.48-11.997L.006 55.58Z"
      fill="#F6820C"
    />
    <path
      d="m28.133 68.258 23.515-12.737-6.72-40.165a1.542 1.542 0 0 0-.368-.765 1.612 1.612 0 0 0-.725-.467 1.653 1.653 0 0 0-.87-.031 1.62 1.62 0 0 0-.758.412L0 55.578l23.376 12.678c.726.394 1.545.6 2.377.6.832 0 1.65-.206 2.377-.6"
      fill="#FDE068"
    />
    <path
      d="M51.432 55.415 44.77 15.553a1.344 1.344 0 0 0-.27-.75 1.407 1.407 0 0 0-.655-.479 1.45 1.45 0 0 0-.818-.044 1.42 1.42 0 0 0-.705.405L.253 55.501l23.118 12.544c.72.39 1.532.595 2.358.595.826 0 1.637-.205 2.358-.596l23.345-12.629Z"
      fill="#FCCA3F"
    />
    <path
      d="M28.133 67.875c-.727.394-1.545.6-2.377.6-.833 0-1.651-.206-2.378-.6L.192 55.385 0 55.579l23.376 12.678c.726.394 1.545.6 2.377.6.832 0 1.65-.206 2.377-.6l23.518-12.735-.059-.344-23.456 12.698Z"
      fill="#EEAB37"
    />
  </svg>
);
export default SvgFirebase;
